module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8G6hP"))).then(() => parcelRequire('5erN3'));